// extracted by mini-css-extract-plugin
export var table = "_xe-0";